const T = {
  es: {
    permissions: "Permisos", permissions_hint: "Toca el módulo para activar/desactivar todo. Ver es obligatorio para las demás acciones.",
    p_view: "Ver", p_add: "Crear", p_edit: "Editar", p_delete: "Borrar",
    consumos: "Consumos", facturas: "Facturas", cxc: "Cuentas por Cobrar",
    new_consumption: "Nuevo Consumo", issue_invoice: "Emitir Factura", ncf_type: "Tipo NCF",
    ncf_sequences: "Secuencias NCF", new_sequence: "Nueva Secuencia",
    fiscal_credit: "Crédito Fiscal", final_consumer: "Consumidor Final",
    special_regime: "Régimen Especial", government: "Gubernamental",
    select_sale: "Seleccionar venta", voided: "Anulada", current: "Actual", until: "Hasta", from: "Desde",
    total_receivable: "Total por Cobrar", debtor_clients: "Clientes con deuda", aging: "Antigüedad de saldos",
    no_debts: "No hay deudas pendientes", total_pending: "Total Pendiente",
    reason: "Motivo", reason_placeholder: "Ej: alimentación lote engorde", optional: "opcional",
    compras: "Compras", proveedores: "Proveedores", new_purchase: "Nueva Compra",
    new_supplier: "Nuevo Proveedor", unit_cost: "Costo unitario", add_at_least_one_item: "Agrega al menos un producto",
    // General
    app_name: "GranjaApp", home: "Inicio", search_placeholder: "Buscar cliente, producto, galpón, lote...",
    save: "Guardar", cancel: "Cancelar", delete: "Eliminar", edit: "Editar", create: "Crear",
    close: "Cerrar", back: "Atrás", loading: "Cargando...", error: "Error", success: "Éxito",
    confirm_delete: "¿Eliminar? Esta acción no se puede deshacer.",
    logout: "Salir", settings: "Ajustes", yes: "Sí", no: "No",
    // Auth
    email: "Email", password: "Contraseña", login: "Entrar", login_error: "Email o contraseña incorrectos",
    // Dashboard
    hello: "Hola", alerts: "Alertas", admin: "Administrador", supervisor: "Supervisor",
    // Modules
    galpones: "Galpones", engorde: "Engorde", ponedoras: "Ponedoras", incubadora: "Incubadora",
    inventario: "Inventario", ventas: "Ventas", clientes: "Clientes", reportes: "Reportes",
    gastos: "Gastos", finanzas: "Finanzas", empleados: "Empleados", usuarios: "Usuarios",
    // Galpones
    new_galpon: "Nuevo Galpón", capacity: "Capacidad (aves)", type: "Tipo", location: "Ubicación",
    name: "Nombre", active: "Activo", inactive: "Inactivo",
    // Lotes
    new_lote: "Nuevo Lote", code: "Código", breed: "Raza", quantity: "Cantidad inicial",
    entry_date: "Fecha ingreso", supplier: "Proveedor", active_lotes: "Activos", closed_lotes: "Cerrados",
    // Records
    daily_record: "Registro Diario", mortality: "Mortalidad", feed_lb: "Alimento (lb)",
    water_gal: "Agua (gal)", weight_lb: "Peso muestra (lb)", observations: "Observaciones",
    // Ponedoras
    eggs_collected: "Huevos recolectados", eggs_broken: "Huevos rotos", eggs_dirty: "Huevos sucios",
    start_date: "Inicio postura", egg_production: "Producción huevos",
    // Incubadora
    new_cycle: "Nuevo Ciclo", eggs_initial: "Huevos", hatching: "Eclosión",
    temperature: "Temperatura (°C)", humidity: "Humedad (%)", born_alive: "Nacidos vivos",
    born_dead: "Nacidos muertos", infertile: "Infértiles", contaminated: "Contaminados",
    // Inventario
    products: "Productos", low_stock: "Bajo mínimo", new_product: "Nuevo Producto",
    stock: "Stock", min_stock: "Stock mínimo", unit: "Unidad", price: "Precio venta",
    movement: "Movimiento", entry: "Entrada", exit: "Salida", consumption: "Consumo", adjustment: "Ajuste",
    // Ventas
    new_sale: "Nueva Venta", total_billed: "Facturado", collected: "Cobrado",
    pending: "Pendiente", paid: "Pagado", partial: "Parcial", payment_method: "Método pago",
    cash: "Efectivo", transfer: "Transferencia", card: "Tarjeta", credit: "Crédito",
    register_payment: "Registrar Pago", payment_history: "Historial de Pagos",
    fully_paid: "Esta cuenta está completamente pagada",
    // Clientes
    new_client: "Nuevo Cliente", phone: "Teléfono", address: "Dirección",
    doc_type: "Tipo documento", cedula: "Cédula", rnc: "RNC (empresa)", passport: "Pasaporte",
    // Reportes
    financial: "Financiero", production: "Producción", net_profit: "Utilidad Neta",
    margin: "Margen", income: "Ingresos", expenses: "Egresos", payroll: "Nómina",
    inventory_purchases: "Compras inventario", by_category: "Por Categoría",
    // Gastos
    new_expense: "Registrar Gasto", category: "Categoría",
    veterinary: "Veterinaria", payroll_cat: "Nómina / Empleados", feed_cat: "Alimento",
    transport: "Transporte", services: "Servicios (agua, luz)", maintenance: "Mantenimiento", other: "Otro",
    // Empleados
    new_employee: "Nuevo Empleado", position: "Cargo", monthly_salary: "Salario mensual",
    register_pay: "Registrar Pago", period: "Período", total_paid: "Total pagado",
    // Usuarios
    new_user: "Crear Usuario", role: "Rol / Permisos", assigned_galpones: "Galpones asignados",
    full_access: "Acceso total", field_operator: "Operario Campo",
    // Batch 2
    navigation: "Navegación", administration: "Administración", logout_desc: "Salir de la aplicación",
    overview: "Vista general", stock_movements: "Stock y movimientos",
    purchase_history: "Historial de Compras", payment_history_full: "Historial de Pagos",
    movement_history: "Historial de Movimientos", last_payments: "Últimos Pagos",
    full_name: "Nombre completo", monthly_payroll: "Nómina mensual",
    close_session: "Cerrar Sesión", register_expense: "Registrar Gasto",
    create_cycle: "Crear Ciclo", save_record: "Guardar Registro",
    finish_save: "Finalizar y Guardar", select_batch: "Seleccionar Lote",
    no_sales: "No hay ventas", no_payments: "No hay pagos registrados",
    no_products: "No hay productos", no_movements: "Sin movimientos registrados",
    product_label: "Producto", sku: "SKU", min_stock_label: "Stock mínimo",
    units: "Unidades", transfer_pay: "Transferencia", card_pay: "Tarjeta",
    doc_type_short: "Tipo doc", register_credit: "Registrar Abono",
    alive_birds: "Aves vivas", general_balance: "Balance General",
    expenses_by_cat: "Gastos por Categoría", investment_recovery: "Inversión vs Recuperación",
    sales_by_day: "Ventas por día", total_value: "Valor total",
    top_products_label: "Top Productos", net_profit_label: "Utilidad Neta",
    services_cat: "Servicios", other_cat: "Otros", inactive_count: "Inactivos",
    poultry_mgmt: "Gestión Avícola", rnc_label: "RNC",
    // Batch 3 - tabs, categories, financial
    active_tab: "Activos", closed_tab: "Cerrados", finished_tab: "Finalizados",
    paid_tab: "Pagados", pending_tab: "Pendientes", active_count: "Activo",
    confirm_delete_client: "¿Eliminar este cliente? Esta acción no se puede deshacer.",
    confirm_deactivate: "¿Desactivar este galpón?", confirm_logout: "¿Cerrar sesión?",
    edit_galpon: "Editar Galpón", new_galpon_title: "Nuevo Galpón",
    loss: "Pérdida", profit: "Ganancia", total_invested: "Total Invertido",
    investment: "Inversión", income_sales: "Ingresos (Ventas)",
    view_expenses: "Ver Gastos", view_sales: "Ver Ventas",
    cat_veterinary: "🏥 Veterinaria", cat_payroll: "👷 Nómina / Empleados",
    cat_feed: "🌾 Alimento", cat_transport: "🚛 Transporte",
    cat_services: "💡 Servicios (agua, luz)", cat_maintenance: "🔧 Mantenimiento",
    cat_other: "📋 Otro", production: "Producción",
    feed_consumed: "Alimento consumido", feed_lb_label: "Alimento (lb)",
    hatching_event: "¡Eclosión!", search_employee: "escribe para buscar empleado",
    mgmt_lots_inv_sales: "Gestión lotes, inventario, ventas",
    // Batch 4 - remaining UI labels
    capacity_birds: "Capacidad (aves)", stock_label: "Stock:", min_label: "mín:",
    margin_label: "Margen:", type_label: "Tipo:", galpon_label: "Galpón:",
    client_label: "Cliente:", amount_usd: "Monto ($)", sale_price: "Precio venta ($)",
    add_galpon: "+ Agregar galpón", new_lote_btn: "+ Nuevo Lote",
    new_daily_record: "+ Nuevo Registro Diario", register_movement: "↕️ Registrar Movimiento",
    register_temp: "🌡️ Registrar", edit_btn: "✏️ Editar", delete_btn: "🗑 Eliminar",
    add_product: "+ Agregar producto", no_expenses_yet: "No hay gastos registrados aún",
    active_lotes_label: "Lotes activos:", broiler_type: "🐔 Engorde (pollos)",
    layer_type: "🥚 Ponedoras (huevos)", mixed_type: "🔄 Mixto",
    hatchery_type: "🐣 Incubadora", birds_unit: "aves",
    search_client: "buscar cliente", new_cycle_btn: "+ Nuevo Ciclo",
    // Alerts
    low_stock: "Stock bajo", high_mortality: "Mortalidad alta",
    hatching_soon: "Eclosión próxima", pending_collections: "Cobros pendientes",
    stock_detail_fmt: "{valor} {unidad} (mín: {minimo})",
    mortality_detail_fmt: "{muertes} muertes ({porcentaje}%) en {dias} días",
    hatching_detail_fmt: "Día {dia}/21 - {restantes} días restantes",
    collection_detail_fmt: "${total} por cobrar ({count} ventas)",
    // UI Actions
    save_success: "Guardado", created: "Creado", updated: "Actualizado", deleted: "Eliminado",
    error_loading: "Error cargando datos", error_saving: "No se pudo guardar", error_deleting: "No se pudo eliminar",
    required_fields: "Campos requeridos", no_records: "Sin registros",
    // Common labels
    date: "Fecha", concept: "Concepto", amount: "Monto", notes: "Notas", total: "Total",
    status: "Estado", search: "Buscar", all: "Todos", from_date: "Desde", to_date: "Hasta",
    birds: "Aves", days: "Días", alive: "Vivas", up_to_date: "Al día",
    // Galpones
    no_galpones: "No hay galpones registrados", occupancy: "Ocupación",
    create_lote: "Crear lote", no_active_lotes: "No hay lotes activos",
    // Lotes
    batch_code: "Código del lote", initial_qty: "Cantidad inicial",
    no_closed_lotes: "No hay lotes cerrados", no_breed: "Sin raza",
    feed: "Alimento", water: "Agua", conversion: "Conversión", no_records_yet: "Sin registros aún",
    weighed: "Pollos pesados", mortality_cause: "Causa mortalidad",
    // Ponedoras
    start_laying: "Inicio postura", broken: "Rotos", dirty: "Sucios",
    no_active_layers: "No hay lotes de ponedoras activos",
    // Incubadora
    hatching_eggs: "Huevos", alive_born: "Vivos", dead_born: "Muertos",
    no_active_cycles: "No hay ciclos activos", no_finished_cycles: "No hay ciclos finalizados",
    // Inventario
    dose: "Dosis", gallons: "Galones", grams: "Gramos", kg: "Kg", pounds: "Libras",
    below_min: "Bajo mínimo", product_type: "Tipo producto",
    feed_type: "Alimento", medicine: "Medicamento", supply: "Insumo",
    egg_type: "Huevo", chick: "Pollito", manure: "Gallinaza",
    // Ventas
    client: "Cliente", billed: "Facturado",
    // Empleados
    hire_date: "Fecha ingreso", pay_date: "Fecha pago", no_position: "Sin cargo",
    no_employees: "No hay empleados registrados",
    // Gastos
    no_expenses: "No hay gastos registrados",
    // Reportes
    operational_expenses: "Gastos operativos", inventory_buys: "Compras inventario",
    top_products: "Top productos", batches: "Lotes",
    // Usuarios
    activate: "Activar", deactivate: "Desactivar", activated: "Activado", deactivated: "Desactivado",
    new_password: "Nueva contraseña", daily_records: "Registros diarios",
    sales_registry: "Registro ventas", hatching_mgmt: "Gestión incubadora",
    feed_formulas: "Fórmulas alimento",
    // Ajustes descriptions
    desc_galpones: "Gestión de galpones", desc_engorde: "Pollos para venta",
    desc_ponedoras: "Producción de huevos", desc_incubadora: "Ciclos de incubación",
    desc_finanzas: "Inversión vs ventas", desc_empleados: "Nómina y pagos",
    desc_usuarios: "Crear y gestionar usuarios",
  },
  en: {
    permissions: "Permissions", permissions_hint: "Tap the module to toggle all. View is required for other actions.",
    p_view: "View", p_add: "Add", p_edit: "Edit", p_delete: "Delete",
    consumos: "Consumption", facturas: "Invoices", cxc: "Accounts Receivable",
    new_consumption: "New Consumption", issue_invoice: "Issue Invoice", ncf_type: "NCF Type",
    ncf_sequences: "NCF Sequences", new_sequence: "New Sequence",
    fiscal_credit: "Fiscal Credit", final_consumer: "Final Consumer",
    special_regime: "Special Regime", government: "Government",
    select_sale: "Select sale", voided: "Voided", current: "Current", until: "Until", from: "From",
    total_receivable: "Total Receivable", debtor_clients: "Debtor clients", aging: "Aging",
    no_debts: "No pending debts", total_pending: "Total Pending",
    reason: "Reason", reason_placeholder: "E.g: broiler batch feeding", optional: "optional",
    compras: "Purchases", proveedores: "Suppliers", new_purchase: "New Purchase",
    new_supplier: "New Supplier", unit_cost: "Unit cost", add_at_least_one_item: "Add at least one product",
    app_name: "FarmApp", home: "Home", search_placeholder: "Search client, product, barn, batch...",
    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", create: "Create",
    close: "Close", back: "Back", loading: "Loading...", error: "Error", success: "Success",
    confirm_delete: "Delete? This action cannot be undone.",
    logout: "Logout", settings: "Settings", yes: "Yes", no: "No",
    email: "Email", password: "Password", login: "Sign In", login_error: "Invalid email or password",
    hello: "Hello", alerts: "Alerts", admin: "Administrator", supervisor: "Supervisor",
    galpones: "Barns", engorde: "Broilers", ponedoras: "Layers", incubadora: "Hatchery",
    inventario: "Inventory", ventas: "Sales", clientes: "Clients", reportes: "Reports",
    gastos: "Expenses", finanzas: "Finance", empleados: "Employees", usuarios: "Users",
    new_galpon: "New Barn", capacity: "Capacity (birds)", type: "Type", location: "Location",
    name: "Name", active: "Active", inactive: "Inactive",
    new_lote: "New Batch", code: "Code", breed: "Breed", quantity: "Initial quantity",
    entry_date: "Entry date", supplier: "Supplier", active_lotes: "Active", closed_lotes: "Closed",
    daily_record: "Daily Record", mortality: "Mortality", feed_lb: "Feed (lb)",
    water_gal: "Water (gal)", weight_lb: "Sample weight (lb)", observations: "Observations",
    eggs_collected: "Eggs collected", eggs_broken: "Broken eggs", eggs_dirty: "Dirty eggs",
    start_date: "Start laying", egg_production: "Egg production",
    new_cycle: "New Cycle", eggs_initial: "Eggs", hatching: "Hatching",
    temperature: "Temperature (°C)", humidity: "Humidity (%)", born_alive: "Born alive",
    born_dead: "Born dead", infertile: "Infertile", contaminated: "Contaminated",
    products: "Products", low_stock: "Low stock", new_product: "New Product",
    stock: "Stock", min_stock: "Min stock", unit: "Unit", price: "Sale price",
    movement: "Movement", entry: "Entry", exit: "Exit", consumption: "Consumption", adjustment: "Adjustment",
    new_sale: "New Sale", total_billed: "Billed", collected: "Collected",
    pending: "Pending", paid: "Paid", partial: "Partial", payment_method: "Payment method",
    cash: "Cash", transfer: "Transfer", card: "Card", credit: "Credit",
    register_payment: "Register Payment", payment_history: "Payment History",
    fully_paid: "This account is fully paid",
    new_client: "New Client", phone: "Phone", address: "Address",
    doc_type: "Document type", cedula: "ID Card", rnc: "Tax ID (company)", passport: "Passport",
    financial: "Financial", production: "Production", net_profit: "Net Profit",
    margin: "Margin", income: "Income", expenses: "Expenses", payroll: "Payroll",
    inventory_purchases: "Inventory purchases", by_category: "By Category",
    new_expense: "Register Expense", category: "Category",
    veterinary: "Veterinary", payroll_cat: "Payroll", feed_cat: "Feed",
    transport: "Transport", services: "Utilities", maintenance: "Maintenance", other: "Other",
    new_employee: "New Employee", position: "Position", monthly_salary: "Monthly salary",
    register_pay: "Register Payment", period: "Period", total_paid: "Total paid",
    new_user: "Create User", role: "Role / Permissions", assigned_galpones: "Assigned barns",
    full_access: "Full access", field_operator: "Field Operator",
    navigation: "Navigation", administration: "Administration", logout_desc: "Sign out of the application",
    overview: "Overview", stock_movements: "Stock & movements",
    purchase_history: "Purchase History", payment_history_full: "Payment History",
    movement_history: "Movement History", last_payments: "Last Payments",
    full_name: "Full name", monthly_payroll: "Monthly payroll",
    close_session: "Sign Out", register_expense: "Register Expense",
    create_cycle: "Create Cycle", save_record: "Save Record",
    finish_save: "Finish & Save", select_batch: "Select Batch",
    no_sales: "No sales", no_payments: "No payments registered",
    no_products: "No products", no_movements: "No movements registered",
    product_label: "Product", sku: "SKU", min_stock_label: "Min stock",
    units: "Units", transfer_pay: "Transfer", card_pay: "Card",
    doc_type_short: "Doc type", register_credit: "Register Payment",
    alive_birds: "Alive birds", general_balance: "General Balance",
    expenses_by_cat: "Expenses by Category", investment_recovery: "Investment vs Recovery",
    sales_by_day: "Sales by day", total_value: "Total value",
    top_products_label: "Top Products", net_profit_label: "Net Profit",
    services_cat: "Services", other_cat: "Other", inactive_count: "Inactive",
    poultry_mgmt: "Poultry Management", rnc_label: "Tax ID",
    active_tab: "Active", closed_tab: "Closed", finished_tab: "Finished",
    paid_tab: "Paid", pending_tab: "Pending", active_count: "Active",
    confirm_delete_client: "Delete this client? This action cannot be undone.",
    confirm_deactivate: "Deactivate this barn?", confirm_logout: "Sign out?",
    edit_galpon: "Edit Barn", new_galpon_title: "New Barn",
    loss: "Loss", profit: "Profit", total_invested: "Total Invested",
    investment: "Investment", income_sales: "Income (Sales)",
    view_expenses: "View Expenses", view_sales: "View Sales",
    cat_veterinary: "🏥 Veterinary", cat_payroll: "👷 Payroll",
    cat_feed: "🌾 Feed", cat_transport: "🚛 Transport",
    cat_services: "💡 Utilities", cat_maintenance: "🔧 Maintenance",
    cat_other: "📋 Other", production: "Production",
    feed_consumed: "Feed consumed", feed_lb_label: "Feed (lb)",
    hatching_event: "Hatching!", search_employee: "type to search employee",
    mgmt_lots_inv_sales: "Lots, inventory, sales management",
    capacity_birds: "Capacity (birds)", stock_label: "Stock:", min_label: "min:",
    margin_label: "Margin:", type_label: "Type:", galpon_label: "Barn:",
    client_label: "Client:", amount_usd: "Amount ($)", sale_price: "Sale price ($)",
    add_galpon: "+ Add barn", new_lote_btn: "+ New Batch",
    new_daily_record: "+ New Daily Record", register_movement: "↕️ Register Movement",
    register_temp: "🌡️ Register", edit_btn: "✏️ Edit", delete_btn: "🗑 Delete",
    add_product: "+ Add product", no_expenses_yet: "No expenses registered yet",
    active_lotes_label: "Active batches:", broiler_type: "🐔 Broilers",
    layer_type: "🥚 Layers", mixed_type: "🔄 Mixed",
    hatchery_type: "🐣 Hatchery", birds_unit: "birds",
    search_client: "search client", new_cycle_btn: "+ New Cycle",
    low_stock: "Low stock", high_mortality: "High mortality",
    hatching_soon: "Hatching soon", pending_collections: "Pending collections",
    stock_detail_fmt: "{valor} {unidad} (min: {minimo})",
    mortality_detail_fmt: "{muertes} deaths ({porcentaje}%) in {dias} days",
    hatching_detail_fmt: "Day {dia}/21 - {restantes} days left",
    collection_detail_fmt: "${total} to collect ({count} sales)",
    save_success: "Saved", created: "Created", updated: "Updated", deleted: "Deleted",
    error_loading: "Error loading data", error_saving: "Could not save", error_deleting: "Could not delete",
    required_fields: "Required fields", no_records: "No records",
    date: "Date", concept: "Concept", amount: "Amount", notes: "Notes", total: "Total",
    status: "Status", search: "Search", all: "All", from_date: "From", to_date: "To",
    birds: "Birds", days: "Days", alive: "Alive", up_to_date: "Up to date",
    no_galpones: "No barns registered", occupancy: "Occupancy",
    create_lote: "Create batch", no_active_lotes: "No active batches",
    batch_code: "Batch code", initial_qty: "Initial quantity",
    no_closed_lotes: "No closed batches", no_breed: "No breed",
    feed: "Feed", water: "Water", conversion: "Conversion", no_records_yet: "No records yet",
    weighed: "Birds weighed", mortality_cause: "Mortality cause",
    start_laying: "Start laying", broken: "Broken", dirty: "Dirty",
    no_active_layers: "No active layer batches",
    hatching_eggs: "Eggs", alive_born: "Alive", dead_born: "Dead",
    no_active_cycles: "No active cycles", no_finished_cycles: "No finished cycles",
    dose: "Dose", gallons: "Gallons", grams: "Grams", kg: "Kg", pounds: "Pounds",
    below_min: "Below minimum", product_type: "Product type",
    feed_type: "Feed", medicine: "Medicine", supply: "Supply",
    egg_type: "Egg", chick: "Chick", manure: "Manure",
    client: "Client", billed: "Billed",
    hire_date: "Hire date", pay_date: "Pay date", no_position: "No position",
    no_employees: "No employees registered",
    no_expenses: "No expenses registered",
    operational_expenses: "Operational expenses", inventory_buys: "Inventory purchases",
    top_products: "Top products", batches: "Batches",
    activate: "Activate", deactivate: "Deactivate", activated: "Activated", deactivated: "Deactivated",
    new_password: "New password", daily_records: "Daily records",
    sales_registry: "Sales registry", hatching_mgmt: "Hatchery management",
    feed_formulas: "Feed formulas",
    desc_galpones: "Barn management", desc_engorde: "Birds for sale",
    desc_ponedoras: "Egg production", desc_incubadora: "Hatching cycles",
    desc_finanzas: "Investment vs sales", desc_empleados: "Payroll & payments",
    desc_usuarios: "Create & manage users",
  },
  fr: {
    permissions: "Permissions", permissions_hint: "Touchez le module pour tout activer. Voir est requis pour les autres actions.",
    p_view: "Voir", p_add: "Créer", p_edit: "Modifier", p_delete: "Supprimer",
    consumos: "Consommations", facturas: "Factures", cxc: "Comptes clients",
    new_consumption: "Nouvelle Consommation", issue_invoice: "Émettre Facture", ncf_type: "Type NCF",
    ncf_sequences: "Séquences NCF", new_sequence: "Nouvelle Séquence",
    fiscal_credit: "Crédit Fiscal", final_consumer: "Consommateur Final",
    special_regime: "Régime Spécial", government: "Gouvernemental",
    select_sale: "Sélectionner vente", voided: "Annulée", current: "Actuel", until: "Jusqu'à", from: "De",
    total_receivable: "Total à recevoir", debtor_clients: "Clients débiteurs", aging: "Ancienneté des soldes",
    no_debts: "Aucune dette en attente", total_pending: "Total en attente",
    reason: "Motif", reason_placeholder: "Ex: alimentation lot engraissement", optional: "facultatif",
    compras: "Achats", proveedores: "Fournisseurs", new_purchase: "Nouvel Achat",
    new_supplier: "Nouveau Fournisseur", unit_cost: "Coût unitaire", add_at_least_one_item: "Ajoutez au moins un produit",
    app_name: "GranjaApp", home: "Accueil", search_placeholder: "Rechercher client, produit, poulailler, lot...",
    save: "Enregistrer", cancel: "Annuler", delete: "Supprimer", edit: "Modifier", create: "Créer",
    close: "Fermer", back: "Retour", loading: "Chargement...", error: "Erreur", success: "Succès",
    confirm_delete: "Supprimer? Cette action est irréversible.",
    logout: "Déconnexion", settings: "Paramètres", yes: "Oui", no: "Non",
    email: "Email", password: "Mot de passe", login: "Connexion", login_error: "Email ou mot de passe incorrect",
    hello: "Bonjour", alerts: "Alertes", admin: "Administrateur", supervisor: "Superviseur",
    galpones: "Poulaillers", engorde: "Engraissement", ponedoras: "Pondeuses", incubadora: "Couvoir",
    inventario: "Inventaire", ventas: "Ventes", clientes: "Clients", reportes: "Rapports",
    gastos: "Dépenses", finanzas: "Finances", empleados: "Employés", usuarios: "Utilisateurs",
    new_galpon: "Nouveau Poulailler", capacity: "Capacité (oiseaux)", type: "Type", location: "Emplacement",
    name: "Nom", active: "Actif", inactive: "Inactif",
    new_lote: "Nouveau Lot", code: "Code", breed: "Race", quantity: "Quantité initiale",
    entry_date: "Date d'entrée", supplier: "Fournisseur", active_lotes: "Actifs", closed_lotes: "Fermés",
    daily_record: "Registre Quotidien", mortality: "Mortalité", feed_lb: "Aliment (lb)",
    water_gal: "Eau (gal)", weight_lb: "Poids échantillon (lb)", observations: "Observations",
    eggs_collected: "Œufs collectés", eggs_broken: "Œufs cassés", eggs_dirty: "Œufs sales",
    start_date: "Début ponte", egg_production: "Production d'œufs",
    new_cycle: "Nouveau Cycle", eggs_initial: "Œufs", hatching: "Éclosion",
    temperature: "Température (°C)", humidity: "Humidité (%)", born_alive: "Nés vivants",
    born_dead: "Mort-nés", infertile: "Infertiles", contaminated: "Contaminés",
    products: "Produits", low_stock: "Stock bas", new_product: "Nouveau Produit",
    stock: "Stock", min_stock: "Stock min", unit: "Unité", price: "Prix vente",
    movement: "Mouvement", entry: "Entrée", exit: "Sortie", consumption: "Consommation", adjustment: "Ajustement",
    new_sale: "Nouvelle Vente", total_billed: "Facturé", collected: "Encaissé",
    pending: "En attente", paid: "Payé", partial: "Partiel", payment_method: "Mode de paiement",
    cash: "Espèces", transfer: "Virement", card: "Carte", credit: "Crédit",
    register_payment: "Enregistrer Paiement", payment_history: "Historique des Paiements",
    fully_paid: "Ce compte est entièrement payé",
    new_client: "Nouveau Client", phone: "Téléphone", address: "Adresse",
    doc_type: "Type de document", cedula: "Carte d'identité", rnc: "N° fiscal", passport: "Passeport",
    financial: "Financier", production: "Production", net_profit: "Bénéfice Net",
    margin: "Marge", income: "Revenus", expenses: "Dépenses", payroll: "Paie",
    inventory_purchases: "Achats inventaire", by_category: "Par Catégorie",
    new_expense: "Enregistrer Dépense", category: "Catégorie",
    veterinary: "Vétérinaire", payroll_cat: "Paie", feed_cat: "Aliment",
    transport: "Transport", services: "Services", maintenance: "Maintenance", other: "Autre",
    new_employee: "Nouvel Employé", position: "Poste", monthly_salary: "Salaire mensuel",
    register_pay: "Enregistrer Paiement", period: "Période", total_paid: "Total payé",
    new_user: "Créer Utilisateur", role: "Rôle / Permissions", assigned_galpones: "Poulaillers assignés",
    full_access: "Accès complet", field_operator: "Opérateur terrain",
    navigation: "Navigation", administration: "Administration", logout_desc: "Quitter l'application",
    overview: "Vue d'ensemble", stock_movements: "Stock et mouvements",
    purchase_history: "Historique achats", payment_history_full: "Historique paiements",
    movement_history: "Historique mouvements", last_payments: "Derniers paiements",
    full_name: "Nom complet", monthly_payroll: "Paie mensuelle",
    close_session: "Déconnexion", register_expense: "Enregistrer dépense",
    create_cycle: "Créer cycle", save_record: "Enregistrer",
    finish_save: "Terminer et enregistrer", select_batch: "Sélectionner lot",
    no_sales: "Aucune vente", no_payments: "Aucun paiement",
    no_products: "Aucun produit", no_movements: "Aucun mouvement",
    product_label: "Produit", sku: "SKU", min_stock_label: "Stock min",
    units: "Unités", transfer_pay: "Virement", card_pay: "Carte",
    doc_type_short: "Type doc", register_credit: "Enregistrer paiement",
    alive_birds: "Oiseaux vivants", general_balance: "Bilan général",
    expenses_by_cat: "Dépenses par catégorie", investment_recovery: "Investissement vs récupération",
    sales_by_day: "Ventes par jour", total_value: "Valeur totale",
    top_products_label: "Top produits", net_profit_label: "Bénéfice net",
    services_cat: "Services", other_cat: "Autres", inactive_count: "Inactifs",
    poultry_mgmt: "Gestion avicole", rnc_label: "N° fiscal",
    active_tab: "Actifs", closed_tab: "Fermés", finished_tab: "Terminés",
    paid_tab: "Payés", pending_tab: "En attente", active_count: "Actif",
    confirm_delete_client: "Supprimer ce client? Action irréversible.",
    confirm_deactivate: "Désactiver ce poulailler?", confirm_logout: "Se déconnecter?",
    edit_galpon: "Modifier poulailler", new_galpon_title: "Nouveau poulailler",
    loss: "Perte", profit: "Bénéfice", total_invested: "Total investi",
    investment: "Investissement", income_sales: "Revenus (Ventes)",
    view_expenses: "Voir dépenses", view_sales: "Voir ventes",
    cat_veterinary: "🏥 Vétérinaire", cat_payroll: "👷 Paie",
    cat_feed: "🌾 Aliment", cat_transport: "🚛 Transport",
    cat_services: "💡 Services", cat_maintenance: "🔧 Maintenance",
    cat_other: "📋 Autre", production: "Production",
    feed_consumed: "Aliment consommé", feed_lb_label: "Aliment (lb)",
    hatching_event: "Éclosion!", search_employee: "tapez pour chercher employé",
    mgmt_lots_inv_sales: "Gestion lots, inventaire, ventes",
    capacity_birds: "Capacité (oiseaux)", stock_label: "Stock:", min_label: "min:",
    margin_label: "Marge:", type_label: "Type:", galpon_label: "Poulailler:",
    client_label: "Client:", amount_usd: "Montant ($)", sale_price: "Prix vente ($)",
    add_galpon: "+ Ajouter poulailler", new_lote_btn: "+ Nouveau lot",
    new_daily_record: "+ Nouveau registre", register_movement: "↕️ Enregistrer mouvement",
    register_temp: "🌡️ Enregistrer", edit_btn: "✏️ Modifier", delete_btn: "🗑 Supprimer",
    add_product: "+ Ajouter produit", no_expenses_yet: "Aucune dépense enregistrée",
    active_lotes_label: "Lots actifs:", broiler_type: "🐔 Engraissement",
    layer_type: "🥚 Pondeuses", mixed_type: "🔄 Mixte",
    hatchery_type: "🐣 Couvoir", birds_unit: "oiseaux",
    search_client: "chercher client", new_cycle_btn: "+ Nouveau cycle",
    low_stock: "Stock bas", high_mortality: "Mortalité élevée",
    hatching_soon: "Éclosion proche", pending_collections: "Encaissements en attente",
    stock_detail_fmt: "{valor} {unidad} (min: {minimo})",
    mortality_detail_fmt: "{muertes} morts ({porcentaje}%) en {dias} jours",
    hatching_detail_fmt: "Jour {dia}/21 - {restantes} jours restants",
    collection_detail_fmt: "${total} à encaisser ({count} ventes)",
    save_success: "Enregistré", created: "Créé", updated: "Mis à jour", deleted: "Supprimé",
    error_loading: "Erreur de chargement", error_saving: "Impossible d'enregistrer", error_deleting: "Impossible de supprimer",
    required_fields: "Champs requis", no_records: "Aucun enregistrement",
    date: "Date", concept: "Concept", amount: "Montant", notes: "Notes", total: "Total",
    status: "Statut", search: "Rechercher", all: "Tous", from_date: "Du", to_date: "Au",
    birds: "Oiseaux", days: "Jours", alive: "Vivants", up_to_date: "À jour",
    no_galpones: "Aucun poulailler", occupancy: "Occupation",
    create_lote: "Créer lot", no_active_lotes: "Aucun lot actif",
    batch_code: "Code du lot", initial_qty: "Quantité initiale",
    no_closed_lotes: "Aucun lot fermé", no_breed: "Sans race",
    feed: "Aliment", water: "Eau", conversion: "Conversion", no_records_yet: "Aucun registre",
    weighed: "Oiseaux pesés", mortality_cause: "Cause mortalité",
    start_laying: "Début ponte", broken: "Cassés", dirty: "Sales",
    no_active_layers: "Aucun lot pondeuses actif",
    hatching_eggs: "Oeufs", alive_born: "Vivants", dead_born: "Morts",
    no_active_cycles: "Aucun cycle actif", no_finished_cycles: "Aucun cycle terminé",
    dose: "Dose", gallons: "Gallons", grams: "Grammes", kg: "Kg", pounds: "Livres",
    below_min: "Sous le minimum", product_type: "Type produit",
    feed_type: "Aliment", medicine: "Médicament", supply: "Fourniture",
    egg_type: "Oeuf", chick: "Poussin", manure: "Fumier",
    client: "Client", billed: "Facturé",
    hire_date: "Date embauche", pay_date: "Date paiement", no_position: "Sans poste",
    no_employees: "Aucun employé",
    no_expenses: "Aucune dépense",
    operational_expenses: "Dépenses opérationnelles", inventory_buys: "Achats inventaire",
    top_products: "Top produits", batches: "Lots",
    activate: "Activer", deactivate: "Désactiver", activated: "Activé", deactivated: "Désactivé",
    new_password: "Nouveau mot de passe", daily_records: "Registres quotidiens",
    sales_registry: "Registre ventes", hatching_mgmt: "Gestion couvoir",
    feed_formulas: "Formules aliment",
    desc_galpones: "Gestion poulaillers", desc_engorde: "Oiseaux à vendre",
    desc_ponedoras: "Production d'oeufs", desc_incubadora: "Cycles d'incubation",
    desc_finanzas: "Investissement vs ventes", desc_empleados: "Paie et paiements",
    desc_usuarios: "Créer et gérer utilisateurs",
  },
  de: {
    permissions: "Berechtigungen", permissions_hint: "Modul tippen zum Umschalten. Ansehen ist für andere Aktionen erforderlich.",
    p_view: "Ansehen", p_add: "Erstellen", p_edit: "Bearbeiten", p_delete: "Löschen",
    consumos: "Verbrauch", facturas: "Rechnungen", cxc: "Forderungen",
    new_consumption: "Neuer Verbrauch", issue_invoice: "Rechnung erstellen", ncf_type: "NCF-Typ",
    ncf_sequences: "NCF-Sequenzen", new_sequence: "Neue Sequenz",
    fiscal_credit: "Steuergutschrift", final_consumer: "Endverbraucher",
    special_regime: "Sonderregime", government: "Regierung",
    select_sale: "Verkauf wählen", voided: "Storniert", current: "Aktuell", until: "Bis", from: "Von",
    total_receivable: "Gesamtforderung", debtor_clients: "Schuldner", aging: "Fälligkeitsanalyse",
    no_debts: "Keine offenen Schulden", total_pending: "Gesamt offen",
    reason: "Grund", reason_placeholder: "Z.B: Fütterung Mastcharge", optional: "optional",
    compras: "Einkäufe", proveedores: "Lieferanten", new_purchase: "Neuer Einkauf",
    new_supplier: "Neuer Lieferant", unit_cost: "Stückkosten", add_at_least_one_item: "Mindestens ein Produkt hinzufügen",
    app_name: "GranjaApp", home: "Startseite", search_placeholder: "Kunde, Produkt, Stall, Charge suchen...",
    save: "Speichern", cancel: "Abbrechen", delete: "Löschen", edit: "Bearbeiten", create: "Erstellen",
    close: "Schließen", back: "Zurück", loading: "Laden...", error: "Fehler", success: "Erfolg",
    confirm_delete: "Löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
    logout: "Abmelden", settings: "Einstellungen", yes: "Ja", no: "Nein",
    email: "E-Mail", password: "Passwort", login: "Anmelden", login_error: "E-Mail oder Passwort ungültig",
    hello: "Hallo", alerts: "Warnungen", admin: "Administrator", supervisor: "Aufseher",
    galpones: "Ställe", engorde: "Mast", ponedoras: "Legehennen", incubadora: "Brutkasten",
    inventario: "Inventar", ventas: "Verkäufe", clientes: "Kunden", reportes: "Berichte",
    gastos: "Ausgaben", finanzas: "Finanzen", empleados: "Mitarbeiter", usuarios: "Benutzer",
    new_galpon: "Neuer Stall", capacity: "Kapazität (Vögel)", type: "Typ", location: "Standort",
    name: "Name", active: "Aktiv", inactive: "Inaktiv",
    new_lote: "Neue Charge", code: "Code", breed: "Rasse", quantity: "Anfangsmenge",
    entry_date: "Eingangsdatum", supplier: "Lieferant", active_lotes: "Aktiv", closed_lotes: "Geschlossen",
    daily_record: "Tagesbericht", mortality: "Mortalität", feed_lb: "Futter (lb)",
    water_gal: "Wasser (gal)", weight_lb: "Probengewicht (lb)", observations: "Bemerkungen",
    eggs_collected: "Gesammelte Eier", eggs_broken: "Zerbrochene Eier", eggs_dirty: "Schmutzige Eier",
    start_date: "Legebeginn", egg_production: "Eierproduktion",
    new_cycle: "Neuer Zyklus", eggs_initial: "Eier", hatching: "Schlüpfen",
    temperature: "Temperatur (°C)", humidity: "Luftfeuchtigkeit (%)", born_alive: "Lebend geschlüpft",
    born_dead: "Tot geschlüpft", infertile: "Unfruchtbar", contaminated: "Kontaminiert",
    products: "Produkte", low_stock: "Niedriger Bestand", new_product: "Neues Produkt",
    stock: "Bestand", min_stock: "Mindestbestand", unit: "Einheit", price: "Verkaufspreis",
    movement: "Bewegung", entry: "Eingang", exit: "Ausgang", consumption: "Verbrauch", adjustment: "Anpassung",
    new_sale: "Neuer Verkauf", total_billed: "In Rechnung", collected: "Eingezogen",
    pending: "Ausstehend", paid: "Bezahlt", partial: "Teilweise", payment_method: "Zahlungsmethode",
    cash: "Bar", transfer: "Überweisung", card: "Karte", credit: "Kredit",
    register_payment: "Zahlung Registrieren", payment_history: "Zahlungsverlauf",
    fully_paid: "Dieses Konto ist vollständig bezahlt",
    new_client: "Neuer Kunde", phone: "Telefon", address: "Adresse",
    doc_type: "Dokumenttyp", cedula: "Personalausweis", rnc: "Steuer-Nr", passport: "Reisepass",
    financial: "Finanziell", production: "Produktion", net_profit: "Nettogewinn",
    margin: "Marge", income: "Einnahmen", expenses: "Ausgaben", payroll: "Gehälter",
    inventory_purchases: "Inventarkäufe", by_category: "Nach Kategorie",
    new_expense: "Ausgabe Erfassen", category: "Kategorie",
    veterinary: "Tierarzt", payroll_cat: "Gehälter", feed_cat: "Futter",
    transport: "Transport", services: "Dienstleistungen", maintenance: "Wartung", other: "Sonstiges",
    new_employee: "Neuer Mitarbeiter", position: "Position", monthly_salary: "Monatsgehalt",
    register_pay: "Zahlung Registrieren", period: "Zeitraum", total_paid: "Gesamt bezahlt",
    new_user: "Benutzer Erstellen", role: "Rolle / Berechtigungen", assigned_galpones: "Zugewiesene Ställe",
    full_access: "Vollzugriff", field_operator: "Feldarbeiter",
    navigation: "Navigation", administration: "Verwaltung", logout_desc: "Abmelden",
    overview: "Übersicht", stock_movements: "Bestand und Bewegungen",
    purchase_history: "Kaufhistorie", payment_history_full: "Zahlungsverlauf",
    movement_history: "Bewegungsverlauf", last_payments: "Letzte Zahlungen",
    full_name: "Vollständiger Name", monthly_payroll: "Monatsgehalt",
    close_session: "Abmelden", register_expense: "Ausgabe erfassen",
    create_cycle: "Zyklus erstellen", save_record: "Speichern",
    finish_save: "Beenden und speichern", select_batch: "Charge wählen",
    no_sales: "Keine Verkäufe", no_payments: "Keine Zahlungen",
    no_products: "Keine Produkte", no_movements: "Keine Bewegungen",
    product_label: "Produkt", sku: "SKU", min_stock_label: "Mindestbestand",
    units: "Einheiten", transfer_pay: "Überweisung", card_pay: "Karte",
    doc_type_short: "Dok-Typ", register_credit: "Zahlung registrieren",
    alive_birds: "Lebende Vögel", general_balance: "Gesamtbilanz",
    expenses_by_cat: "Ausgaben nach Kategorie", investment_recovery: "Investition vs Ertrag",
    sales_by_day: "Verkäufe pro Tag", total_value: "Gesamtwert",
    top_products_label: "Top Produkte", net_profit_label: "Nettogewinn",
    services_cat: "Dienstleistungen", other_cat: "Sonstiges", inactive_count: "Inaktiv",
    poultry_mgmt: "Geflügelverwaltung", rnc_label: "Steuer-Nr",
    active_tab: "Aktiv", closed_tab: "Geschlossen", finished_tab: "Beendet",
    paid_tab: "Bezahlt", pending_tab: "Ausstehend", active_count: "Aktiv",
    confirm_delete_client: "Diesen Kunden löschen? Nicht rückgängig.",
    confirm_deactivate: "Diesen Stall deaktivieren?", confirm_logout: "Abmelden?",
    edit_galpon: "Stall bearbeiten", new_galpon_title: "Neuer Stall",
    loss: "Verlust", profit: "Gewinn", total_invested: "Gesamt investiert",
    investment: "Investition", income_sales: "Einnahmen (Verkäufe)",
    view_expenses: "Ausgaben ansehen", view_sales: "Verkäufe ansehen",
    cat_veterinary: "🏥 Tierarzt", cat_payroll: "👷 Gehälter",
    cat_feed: "🌾 Futter", cat_transport: "🚛 Transport",
    cat_services: "💡 Dienstleistungen", cat_maintenance: "🔧 Wartung",
    cat_other: "📋 Sonstiges", production: "Produktion",
    feed_consumed: "Futter verbraucht", feed_lb_label: "Futter (lb)",
    hatching_event: "Schlüpfen!", search_employee: "Mitarbeiter suchen",
    mgmt_lots_inv_sales: "Chargen, Inventar, Verkaufsverwaltung",
    capacity_birds: "Kapazität (Vögel)", stock_label: "Bestand:", min_label: "Min:",
    margin_label: "Marge:", type_label: "Typ:", galpon_label: "Stall:",
    client_label: "Kunde:", amount_usd: "Betrag ($)", sale_price: "Verkaufspreis ($)",
    add_galpon: "+ Stall hinzufügen", new_lote_btn: "+ Neue Charge",
    new_daily_record: "+ Neuer Tagesbericht", register_movement: "↕️ Bewegung erfassen",
    register_temp: "🌡️ Erfassen", edit_btn: "✏️ Bearbeiten", delete_btn: "🗑 Löschen",
    add_product: "+ Produkt hinzufügen", no_expenses_yet: "Keine Ausgaben registriert",
    active_lotes_label: "Aktive Chargen:", broiler_type: "🐔 Mast",
    layer_type: "🥚 Legehennen", mixed_type: "🔄 Gemischt",
    hatchery_type: "🐣 Brutkasten", birds_unit: "Vögel",
    search_client: "Kunde suchen", new_cycle_btn: "+ Neuer Zyklus",
    low_stock: "Niedriger Bestand", high_mortality: "Hohe Mortalität",
    hatching_soon: "Schlüpfen bald", pending_collections: "Ausstehende Einzüge",
    stock_detail_fmt: "{valor} {unidad} (Min: {minimo})",
    mortality_detail_fmt: "{muertes} Tote ({porcentaje}%) in {dias} Tagen",
    hatching_detail_fmt: "Tag {dia}/21 - {restantes} Tage übrig",
    collection_detail_fmt: "${total} einzuziehen ({count} Verkäufe)",
    save_success: "Gespeichert", created: "Erstellt", updated: "Aktualisiert", deleted: "Gelöscht",
    error_loading: "Fehler beim Laden", error_saving: "Speichern fehlgeschlagen", error_deleting: "Löschen fehlgeschlagen",
    required_fields: "Pflichtfelder", no_records: "Keine Einträge",
    date: "Datum", concept: "Konzept", amount: "Betrag", notes: "Notizen", total: "Gesamt",
    status: "Status", search: "Suchen", all: "Alle", from_date: "Von", to_date: "Bis",
    birds: "Vögel", days: "Tage", alive: "Lebend", up_to_date: "Aktuell",
    no_galpones: "Keine Ställe registriert", occupancy: "Belegung",
    create_lote: "Charge erstellen", no_active_lotes: "Keine aktiven Chargen",
    batch_code: "Chargencode", initial_qty: "Anfangsmenge",
    no_closed_lotes: "Keine geschlossenen Chargen", no_breed: "Keine Rasse",
    feed: "Futter", water: "Wasser", conversion: "Umwandlung", no_records_yet: "Noch keine Einträge",
    weighed: "Gewogene Vögel", mortality_cause: "Todesursache",
    start_laying: "Legebeginn", broken: "Zerbrochen", dirty: "Schmutzig",
    no_active_layers: "Keine aktiven Legechargen",
    hatching_eggs: "Eier", alive_born: "Lebend", dead_born: "Tot",
    no_active_cycles: "Keine aktiven Zyklen", no_finished_cycles: "Keine beendeten Zyklen",
    dose: "Dosis", gallons: "Gallonen", grams: "Gramm", kg: "Kg", pounds: "Pfund",
    below_min: "Unter Minimum", product_type: "Produkttyp",
    feed_type: "Futter", medicine: "Medikament", supply: "Zubehör",
    egg_type: "Ei", chick: "Küken", manure: "Mist",
    client: "Kunde", billed: "In Rechnung",
    hire_date: "Eintrittsdatum", pay_date: "Zahlungsdatum", no_position: "Keine Position",
    no_employees: "Keine Mitarbeiter",
    no_expenses: "Keine Ausgaben",
    operational_expenses: "Betriebskosten", inventory_buys: "Inventarkäufe",
    top_products: "Top Produkte", batches: "Chargen",
    activate: "Aktivieren", deactivate: "Deaktivieren", activated: "Aktiviert", deactivated: "Deaktiviert",
    new_password: "Neues Passwort", daily_records: "Tagesberichte",
    sales_registry: "Verkaufsregister", hatching_mgmt: "Brutverwaltung",
    feed_formulas: "Futterformeln",
    desc_galpones: "Stallverwaltung", desc_engorde: "Vögel zum Verkauf",
    desc_ponedoras: "Eierproduktion", desc_incubadora: "Brutzzyklen",
    desc_finanzas: "Investition vs Verkäufe", desc_empleados: "Gehälter und Zahlungen",
    desc_usuarios: "Benutzer erstellen und verwalten",
  },
  it: {
    permissions: "Permessi", permissions_hint: "Tocca il modulo per attivare tutto. Vedi è richiesto per le altre azioni.",
    p_view: "Vedi", p_add: "Crea", p_edit: "Modifica", p_delete: "Elimina",
    consumos: "Consumi", facturas: "Fatture", cxc: "Crediti",
    new_consumption: "Nuovo Consumo", issue_invoice: "Emetti Fattura", ncf_type: "Tipo NCF",
    ncf_sequences: "Sequenze NCF", new_sequence: "Nuova Sequenza",
    fiscal_credit: "Credito Fiscale", final_consumer: "Consumatore Finale",
    special_regime: "Regime Speciale", government: "Governativo",
    select_sale: "Seleziona vendita", voided: "Annullata", current: "Attuale", until: "Fino a", from: "Da",
    total_receivable: "Totale da incassare", debtor_clients: "Clienti debitori", aging: "Anzianità saldi",
    no_debts: "Nessun debito in sospeso", total_pending: "Totale in sospeso",
    reason: "Motivo", reason_placeholder: "Es: alimentazione lotto ingrasso", optional: "facoltativo",
    compras: "Acquisti", proveedores: "Fornitori", new_purchase: "Nuovo Acquisto",
    new_supplier: "Nuovo Fornitore", unit_cost: "Costo unitario", add_at_least_one_item: "Aggiungi almeno un prodotto",
    app_name: "GranjaApp", home: "Inizio", search_placeholder: "Cerca cliente, prodotto, pollaio, lotto...",
    save: "Salvare", cancel: "Annulla", delete: "Elimina", edit: "Modifica", create: "Crea",
    close: "Chiudi", back: "Indietro", loading: "Caricamento...", error: "Errore", success: "Successo",
    confirm_delete: "Eliminare? Questa azione non può essere annullata.",
    logout: "Esci", settings: "Impostazioni", yes: "Sì", no: "No",
    email: "Email", password: "Password", login: "Accedi", login_error: "Email o password non validi",
    hello: "Ciao", alerts: "Avvisi", admin: "Amministratore", supervisor: "Supervisore",
    galpones: "Pollai", engorde: "Ingrasso", ponedoras: "Ovaiole", incubadora: "Incubatrice",
    inventario: "Inventario", ventas: "Vendite", clientes: "Clienti", reportes: "Rapporti",
    gastos: "Spese", finanzas: "Finanze", empleados: "Dipendenti", usuarios: "Utenti",
    new_galpon: "Nuovo Pollaio", capacity: "Capacità (uccelli)", type: "Tipo", location: "Posizione",
    name: "Nome", active: "Attivo", inactive: "Inattivo",
    new_lote: "Nuovo Lotto", code: "Codice", breed: "Razza", quantity: "Quantità iniziale",
    entry_date: "Data ingresso", supplier: "Fornitore", active_lotes: "Attivi", closed_lotes: "Chiusi",
    daily_record: "Registro Giornaliero", mortality: "Mortalità", feed_lb: "Mangime (lb)",
    water_gal: "Acqua (gal)", weight_lb: "Peso campione (lb)", observations: "Osservazioni",
    eggs_collected: "Uova raccolte", eggs_broken: "Uova rotte", eggs_dirty: "Uova sporche",
    start_date: "Inizio deposizione", egg_production: "Produzione uova",
    new_cycle: "Nuovo Ciclo", eggs_initial: "Uova", hatching: "Schiusa",
    temperature: "Temperatura (°C)", humidity: "Umidità (%)", born_alive: "Nati vivi",
    born_dead: "Nati morti", infertile: "Infertili", contaminated: "Contaminati",
    products: "Prodotti", low_stock: "Scorta bassa", new_product: "Nuovo Prodotto",
    stock: "Scorta", min_stock: "Scorta min", unit: "Unità", price: "Prezzo vendita",
    movement: "Movimento", entry: "Entrata", exit: "Uscita", consumption: "Consumo", adjustment: "Regolazione",
    new_sale: "Nuova Vendita", total_billed: "Fatturato", collected: "Incassato",
    pending: "In sospeso", paid: "Pagato", partial: "Parziale", payment_method: "Metodo pagamento",
    cash: "Contanti", transfer: "Bonifico", card: "Carta", credit: "Credito",
    register_payment: "Registra Pagamento", payment_history: "Storico Pagamenti",
    fully_paid: "Questo conto è completamente pagato",
    new_client: "Nuovo Cliente", phone: "Telefono", address: "Indirizzo",
    doc_type: "Tipo documento", cedula: "Carta d'identità", rnc: "Partita IVA", passport: "Passaporto",
    financial: "Finanziario", production: "Produzione", net_profit: "Utile Netto",
    margin: "Margine", income: "Entrate", expenses: "Uscite", payroll: "Stipendi",
    inventory_purchases: "Acquisti inventario", by_category: "Per Categoria",
    new_expense: "Registra Spesa", category: "Categoria",
    veterinary: "Veterinario", payroll_cat: "Stipendi", feed_cat: "Mangime",
    transport: "Trasporto", services: "Servizi", maintenance: "Manutenzione", other: "Altro",
    new_employee: "Nuovo Dipendente", position: "Posizione", monthly_salary: "Stipendio mensile",
    register_pay: "Registra Pagamento", period: "Periodo", total_paid: "Totale pagato",
    new_user: "Crea Utente", role: "Ruolo / Permessi", assigned_galpones: "Pollai assegnati",
    full_access: "Accesso completo", field_operator: "Operatore campo",
    navigation: "Navigazione", administration: "Amministrazione", logout_desc: "Esci dall'applicazione",
    overview: "Panoramica", stock_movements: "Scorte e movimenti",
    purchase_history: "Storico acquisti", payment_history_full: "Storico pagamenti",
    movement_history: "Storico movimenti", last_payments: "Ultimi pagamenti",
    full_name: "Nome completo", monthly_payroll: "Stipendio mensile",
    close_session: "Disconnetti", register_expense: "Registra spesa",
    create_cycle: "Crea ciclo", save_record: "Salva registro",
    finish_save: "Termina e salva", select_batch: "Seleziona lotto",
    no_sales: "Nessuna vendita", no_payments: "Nessun pagamento",
    no_products: "Nessun prodotto", no_movements: "Nessun movimento",
    product_label: "Prodotto", sku: "SKU", min_stock_label: "Scorta minima",
    units: "Unità", transfer_pay: "Bonifico", card_pay: "Carta",
    doc_type_short: "Tipo doc", register_credit: "Registra pagamento",
    alive_birds: "Uccelli vivi", general_balance: "Bilancio generale",
    expenses_by_cat: "Spese per categoria", investment_recovery: "Investimento vs recupero",
    sales_by_day: "Vendite per giorno", total_value: "Valore totale",
    top_products_label: "Top prodotti", net_profit_label: "Utile netto",
    services_cat: "Servizi", other_cat: "Altro", inactive_count: "Inattivi",
    poultry_mgmt: "Gestione avicola", rnc_label: "Partita IVA",
    active_tab: "Attivi", closed_tab: "Chiusi", finished_tab: "Terminati",
    paid_tab: "Pagati", pending_tab: "In sospeso", active_count: "Attivo",
    confirm_delete_client: "Eliminare questo cliente? Azione irreversibile.",
    confirm_deactivate: "Disattivare questo pollaio?", confirm_logout: "Disconnettersi?",
    edit_galpon: "Modifica pollaio", new_galpon_title: "Nuovo pollaio",
    loss: "Perdita", profit: "Profitto", total_invested: "Totale investito",
    investment: "Investimento", income_sales: "Entrate (Vendite)",
    view_expenses: "Vedi spese", view_sales: "Vedi vendite",
    cat_veterinary: "🏥 Veterinario", cat_payroll: "👷 Stipendi",
    cat_feed: "🌾 Mangime", cat_transport: "🚛 Trasporto",
    cat_services: "💡 Servizi", cat_maintenance: "🔧 Manutenzione",
    cat_other: "📋 Altro", production: "Produzione",
    feed_consumed: "Mangime consumato", feed_lb_label: "Mangime (lb)",
    hatching_event: "Schiusa!", search_employee: "cerca dipendente",
    mgmt_lots_inv_sales: "Gestione lotti, inventario, vendite",
    capacity_birds: "Capacità (uccelli)", stock_label: "Scorta:", min_label: "min:",
    margin_label: "Margine:", type_label: "Tipo:", galpon_label: "Pollaio:",
    client_label: "Cliente:", amount_usd: "Importo ($)", sale_price: "Prezzo vendita ($)",
    add_galpon: "+ Aggiungi pollaio", new_lote_btn: "+ Nuovo lotto",
    new_daily_record: "+ Nuovo registro", register_movement: "↕️ Registra movimento",
    register_temp: "🌡️ Registra", edit_btn: "✏️ Modifica", delete_btn: "🗑 Elimina",
    add_product: "+ Aggiungi prodotto", no_expenses_yet: "Nessuna spesa registrata",
    active_lotes_label: "Lotti attivi:", broiler_type: "🐔 Ingrasso",
    layer_type: "🥚 Ovaiole", mixed_type: "🔄 Misto",
    hatchery_type: "🐣 Incubatrice", birds_unit: "uccelli",
    search_client: "cerca cliente", new_cycle_btn: "+ Nuovo ciclo",
    low_stock: "Scorta bassa", high_mortality: "Mortalità alta",
    hatching_soon: "Schiusa imminente", pending_collections: "Incassi in sospeso",
    stock_detail_fmt: "{valor} {unidad} (min: {minimo})",
    mortality_detail_fmt: "{muertes} morti ({porcentaje}%) in {dias} giorni",
    hatching_detail_fmt: "Giorno {dia}/21 - {restantes} giorni rimasti",
    collection_detail_fmt: "${total} da incassare ({count} vendite)",
    save_success: "Salvato", created: "Creato", updated: "Aggiornato", deleted: "Eliminato",
    error_loading: "Errore caricamento", error_saving: "Impossibile salvare", error_deleting: "Impossibile eliminare",
    required_fields: "Campi obbligatori", no_records: "Nessun record",
    date: "Data", concept: "Concetto", amount: "Importo", notes: "Note", total: "Totale",
    status: "Stato", search: "Cerca", all: "Tutti", from_date: "Da", to_date: "A",
    birds: "Uccelli", days: "Giorni", alive: "Vivi", up_to_date: "In regola",
    no_galpones: "Nessun pollaio registrato", occupancy: "Occupazione",
    create_lote: "Crea lotto", no_active_lotes: "Nessun lotto attivo",
    batch_code: "Codice lotto", initial_qty: "Quantità iniziale",
    no_closed_lotes: "Nessun lotto chiuso", no_breed: "Senza razza",
    feed: "Mangime", water: "Acqua", conversion: "Conversione", no_records_yet: "Nessun registro",
    weighed: "Uccelli pesati", mortality_cause: "Causa mortalità",
    start_laying: "Inizio deposizione", broken: "Rotti", dirty: "Sporchi",
    no_active_layers: "Nessun lotto ovaiole attivo",
    hatching_eggs: "Uova", alive_born: "Vivi", dead_born: "Morti",
    no_active_cycles: "Nessun ciclo attivo", no_finished_cycles: "Nessun ciclo finito",
    dose: "Dose", gallons: "Galloni", grams: "Grammi", kg: "Kg", pounds: "Libbre",
    below_min: "Sotto il minimo", product_type: "Tipo prodotto",
    feed_type: "Mangime", medicine: "Medicinale", supply: "Fornitura",
    egg_type: "Uovo", chick: "Pulcino", manure: "Concime",
    client: "Cliente", billed: "Fatturato",
    hire_date: "Data assunzione", pay_date: "Data pagamento", no_position: "Senza posizione",
    no_employees: "Nessun dipendente",
    no_expenses: "Nessuna spesa",
    operational_expenses: "Spese operative", inventory_buys: "Acquisti inventario",
    top_products: "Top prodotti", batches: "Lotti",
    activate: "Attivare", deactivate: "Disattivare", activated: "Attivato", deactivated: "Disattivato",
    new_password: "Nuova password", daily_records: "Registri giornalieri",
    sales_registry: "Registro vendite", hatching_mgmt: "Gestione incubatrice",
    feed_formulas: "Formule mangime",
    desc_galpones: "Gestione pollai", desc_engorde: "Uccelli in vendita",
    desc_ponedoras: "Produzione uova", desc_incubadora: "Cicli di incubazione",
    desc_finanzas: "Investimento vs vendite", desc_empleados: "Stipendi e pagamenti",
    desc_usuarios: "Creare e gestire utenti",
  },
};

export default T;
